'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import Navbar from './Navbar';
import Footer from './Footer';
import AppNavbar from './app/navbar';
import GlobalLoadingOverlay from './GlobalLoadingOverlay';
type Props = {
  children: ReactNode;
  variant?: 'root' | 'app' | 'dashboard';
};

export default function AppShell({ children, variant = 'root' }: Props) {
  const pathname = usePathname() || '';

  const isAuthPath =
    pathname.startsWith('/auth') ||
    pathname.startsWith('/login') ||
    pathname.startsWith('/signup') ||
    pathname.startsWith('/onboarding');
  // Consider dashboard group routes such as /settings/* as part of the app area
  const isDashboardArea = pathname.startsWith('/dashboard');
  const isAppArea = pathname.startsWith('/app') || isDashboardArea;

  // Auto-detect variant based on route when variant is left as 'root'
  const effectiveVariant: 'root' | 'app' | 'dashboard' = (() => {
    if (variant !== 'root') return variant;
    if (isDashboardArea) return 'dashboard';
    if (pathname.startsWith('/app')) return 'app';
    return 'root';
  })();

  if (effectiveVariant === 'app' && !isAuthPath) {
    return (
      <div className="flex min-h-screen flex-col">
        <AppNavbar />
        <main className="flex flex-1 justify-center items-center">{children}</main>
        {/* <GlobalLoadingOverlay /> */}
      </div>
    );
  }

  // Dashboard variant does not render the marketing Navbar/Footer
  if (effectiveVariant === 'dashboard' && !isAuthPath) {
    return (
      <div className="flex min-h-screen flex-col">
        <main className="flex-1">{children}</main>
        {/* <GlobalLoadingOverlay /> */}
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col">
      {!isAuthPath && !isAppArea && <Navbar />}
      <main className="flex-1">{children}</main>
      {!isAuthPath && !isAppArea && <Footer />}
      {/* <GlobalLoadingOverlay /> */}
    </div>
  );
}
